import { render, staticRenderFns } from "./AgencyAgents.vue?vue&type=template&id=04a514f2&"
import script from "./AgencyAgents.vue?vue&type=script&lang=js&"
export * from "./AgencyAgents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AgencyAgents.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VFlex,
})
